// Abre un PDF/recurso en otra pestaña. Los links del sistema de contenido
// (".../api/contenido-archivo/{code}?type=...") no se abren directo: se pide
// con el token una URL firmada que vence en 10 minutos. El resto (Drive, PDFs
// viejos) se abre tal cual.
export default async function abrirArchivo(api, url) {
  const match = String(url || "").match(/\/api\/contenido-archivo\/([^?#]+)\??([^#]*)/);
  if (!match) {
    window.open(url, "_blank");
    return;
  }

  // La pestaña se abre antes del await: abierta despues, el navegador la
  // bloquea como popup porque ya no viene directo del click.
  const win = window.open("", "_blank");
  try {
    const res = await api.get({
      url: `contenido-archivo/${match[1]}`,
      data: Object.fromEntries(new URLSearchParams(match[2]))
    });
    win.location.href = res.url;
  } catch (e) {
    // El snackbar del error ya lo muestra Api.js.
    win.close();
  }
}
